import axios from 'axios';
import {checkIsValidAuthenticated, getToken} from "../services/authService";
import {toast} from "react-hot-toast";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

api.interceptors.request.use(
    config => {
        const token = getToken()
        if (token) {
            if(!checkIsValidAuthenticated()) {
                throw new axios.Cancel("Token inválido")
            }
            config.headers['Authorization'] = 'Bearer ' + token
        }
        config.headers['Content-Type'] = 'application/json';
        return config
    },
    error => {
        Promise.reject(error)
    }
)

api.interceptors.response.use(
    function (response) {
        return response.data;
    },
    function (error) {
        if(typeof error.response.data.message === "string") {
            toast.error(error.response.data.message, {
                duration: 4000
            })
        }
        return Promise.reject(error.response.data);
    }
);

export {
    api
}

